import { OptionType } from "../../components/DommusSelect";

export type CampoDinamicoType = {
  id_campo_dinamico: number;
  id_tipo_campo_dinamico: OptionType  | number | null;
  tipo_campo_dinamico: TipoCampoDinamicoType;
  label: string;
  nome?: string;
  options: any;
  oculto: number;
  fluxos_etapas: any
}

export type TipoCampoDinamicoType = {
  id_tipo_campo_dinamico: number;
  nome: string;
}

export enum EnumTipoCampoDinamico {
  TEXTO = 1,
  DATA = 2,
  CPF = 3,
  CEP = 4,
  TELEFONE = 5,
  MONETARIO = 6,
  SIMPLES_SELECAO = 7,
  MULTIPLA_SELECAO = 8,
  CHECKBOX = 9
}
